module.exports = __webpack_public_path__ + "img/zurich.94929409.png";